export default "__VITE_ASSET__BaDzPSt0__"